import { memo, useState, useContext, useEffect } from "react";
import { BootcampList } from "./bootcamp-list";
import { Form } from "./form";
import { PriceList } from "./price-list";
import { Promocode } from "../../../model/promocode";
import { numberWithSpaces } from "../../../utils/number-with-spaces.utils";
import { SiteConfig } from "../../../pages/bootcamp/[slug]";
import { FormCmsData } from "../../../model/form";
import * as Sentry from "@sentry/nextjs";
import { fetchPrice } from "../../../api/api-price";
import { calculateCurrencyPriceWithDiscount } from "../../../utils/price.utils";

interface Props {
  highlights: string[];
  title: string;
  ranking: number;
  startTitle: string;
  promocodes: Promocode[];
  descriptionForPrice: string;
  orTitle: string;
  bootcampTitle: string;
  oldPriceUsdt: number;
  forms: FormCmsData;
  id: string;
}

export const PriceSection = memo<Props>(
  ({
    highlights,
    title,
    ranking,
    promocodes,
    descriptionForPrice,
    forms,
    startTitle,
    orTitle,
    bootcampTitle,
    oldPriceUsdt,
    id,
  }) => {
    const [appliedDiscount, setAppliedDiscount] = useState<number>();
    const [isLoading, setIsLoading] = useState(true);
    const [rubCurrencyRate, setrubCurrencyRate] = useState(0);

    useEffect(() => {
      fetchPrice()
        .then((priceRub) => {
          if (!priceRub) {
            setIsLoading(true);
          } else {
            setrubCurrencyRate(priceRub);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          Sentry.captureException(
            `Ошибка при получении цен в useEffect: ${error}`
          );
          setIsLoading(true);
        });
    }, []);

    const currentDiscountFromCMS = useContext(SiteConfig);

    const priceRubCalculated = calculateCurrencyPriceWithDiscount(
      rubCurrencyRate,
      oldPriceUsdt,
      currentDiscountFromCMS
    );

    const discountFactorFromUserInput = appliedDiscount
      ? appliedDiscount / 100
      : 0;

    const priceRubWithDiscount = Math.floor(
      oldPriceUsdt *
        rubCurrencyRate *
        (1 - currentDiscountFromCMS / 100) *
        (appliedDiscount ? 1 - appliedDiscount / 100 : 1)
    );

    const discountAmountUsdt = oldPriceUsdt * discountFactorFromUserInput;
    const priceUsdtWithDiscount = oldPriceUsdt - discountAmountUsdt;

    return (
      <div id="price" className="lg:bg-white lg:pb-70 max-w-[1360px] m-auto">
        <div className="rounded-[20px] bg-blue pl-5 pr-5 lg:pl-10 lg:pr-10 pb-56 lg:pb-8">
          <h2
            // eslint-disable-next-line
            dangerouslySetInnerHTML={{
              __html: forms.application.title,
            }}
            className="text-[32px] leading-none lg:text-[58px] pt-24 pl-13 pr-13 pb-20 lg:pl-0 lg:pr-0 lg:pt-20 lg:pb-30 text-center text-white"
          ></h2>
          <div className="lg:flex">
            <div className="bg-white lg:flex rounded-[20px] lg:mr-8 lg:w-[66%]">
              <PriceList
                id={id}
                descriptionForPrice={descriptionForPrice}
                priceRub={rubCurrencyRate}
                oldPriceUsdt={oldPriceUsdt}
                appliedDiscount={appliedDiscount}
                orTitle={orTitle}
                isLoading={isLoading}
              />
              <BootcampList
                bootcampTitle={bootcampTitle}
                title={title}
                highlights={highlights}
              />
            </div>
            <Form
              startTitle={startTitle}
              forms={forms}
              bootcampName={title}
              priceRubForEmail={numberWithSpaces(
                Math.floor(priceRubCalculated)
              )}
              priceRub={priceRubCalculated}
              priceUsdt={numberWithSpaces(Math.floor(oldPriceUsdt))}
              promocodes={promocodes}
              ranking={ranking}
              onApplyDiscount={setAppliedDiscount}
              priceRubWithDiscount={priceRubWithDiscount}
              priceUsdtWithDiscount={priceUsdtWithDiscount}
              orTitle={orTitle}
              id={id}
            />
          </div>
        </div>
      </div>
    );
  }
);
